import { defineStore } from 'pinia';
import { delay } from '🔗/utils/utils';
// import stores from '🔗/stores';

const themes = import.meta.env.VITE_APP_THEMES ? import.meta.env.VITE_APP_THEMES.split(',') : [];

const useSettingsStore = defineStore('settings', {
    state: () => ({
        theme: themes?.length ? (localStorage['theme'] && themes.includes(localStorage['theme']) ? localStorage['theme'] : null) : null,
        vibration: localStorage['vibration'] === 'false' ? false : true
    }),
    actions: {
        setTheme(theme) {
            this.theme = theme;

            if (theme) {
                localStorage['theme'] = theme;
            } else {
                delete localStorage['theme'];
            }

            stores.messengers().updateMsgrColors();

            stores.playerPlugin().send({
                type: 'theme',
                payload: {
                    theme: this.theme
                }
            });
        },
        setVibration(vibration) {
            this.vibration = vibration;

            localStorage['vibration'] = !!vibration;

            stores.playerPlugin().send({
                type: 'vibration',
                payload: {
                    vibration: !!vibration
                }
            })
        }
    }
});

export default useSettingsStore;
